/**
 * Helper for convertig \n to <br>.
 *
 * @param {string} value Value to convert
 * @returns {string} Converted value
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default function (value: string): string {
  if (value === undefined || !value) {
    return '';
  }
  const regExp = new RegExp('\n', 'g');
  return value.replace(regExp, '<br>');
}
